import { Card as HeroCard } from "@heroui/react";
import { clsx } from "@/src/common/utils/clsx";

type CardTone = "elevated" | "bordered";

interface CardProps extends React.ComponentProps<typeof HeroCard> {
	tone?: CardTone;
}

/**
 * Thin wrapper matching the two Pencil card variants.
 * - `bordered` (default): flat surface with a 1px border.
 * - `elevated`: same surface with the `surface-shadow` token.
 */
export function Card({ tone = "bordered", className, ...props }: CardProps) {
	const toneClass = tone === "elevated" ? "shadow-md border border-transparent" : "border border-border";
	return <HeroCard className={clsx("rounded-(--radius-l) bg-card p-4", toneClass, className)} {...props} />;
}

Card.Header = HeroCard.Header;
Card.Title = HeroCard.Title;
Card.Description = HeroCard.Description;
Card.Content = HeroCard.Content;
Card.Footer = HeroCard.Footer;
